<form [formGroup]="dateRangeForm">
    <div>
        <div class="flex flex-column gap-2">
            <label for="startDate">تاريخ البداية
                <span class="text-red-500 font-bold">*</span>
            </label>
            <p-calendar id="startDate" formControlName="startDate" type="date" />
        </div>
        @if(dateRangeForm.get('startDate')?.invalid && dateRangeForm.get('startDate')?.touched){
        <div class="text-red-500">
            الحقل مطلوب
            ]
        </div>
        }
    </div>


    <div>
        <div class="flex flex-column gap-2">
            <label for="endDate">تاريخ النهاية

                <span class="text-red-500 font-bold">*</span>
            </label>
            <p-calendar id="endDate" formControlName="endDate" type="date" />
        </div>

        @if(dateRangeForm.get('endDate')?.invalid && dateRangeForm.get('endDate')?.touched){
        <div class="text-red-500">
            الحقل مطلوب
        </div>
        }
    </div>



    @if(dateRangeForm.errors?.['dateRangeInvalid']){

    <div class="text-red-500">
        يجب ألا يكون تاريخ البداية بعد تاريخ الانتهاء.
    </div>
    }
</form>